import { Dashboard } from 'app/pages/Dashboard'
import { DocumentsRegistration } from 'app/pages/DocumentsRegistration'
import { PageNotFound } from 'app/pages/PageNotFound'
import { Profile } from 'app/pages/Profile'
import { SponsorRequestCreate } from 'app/pages/SponsorRequestCreateEdit/SponsorRequestCreate'
import { SponsorRequestEdit } from 'app/pages/SponsorRequestCreateEdit/SponsorRequestEdit'
import { SponsorRequestShow } from 'app/pages/SponsorRequestShow'
import { UserConfirm } from 'app/pages/UserConfirm'
import { UserRegistration } from 'app/pages/UserRegistration'
import { User } from 'EstraSponsor'
import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import { HandledRoute } from './HandledRoute'
import {
  getProtectedRoutes,
  getPublicRoutes,
  protectedRoutes,
  routes,
} from './routes'

type Props = {
  user: User
}

const PrivateAppRouter = ({ user }: Props): JSX.Element => {
  return (
    <Switch>
      <Route exact path={getProtectedRoutes()}>
        {user.sponsorman.status === 'incompleted' ? (
          <Switch>
            <HandledRoute exact path={protectedRoutes.userRegistration.path}>
              <UserRegistration />
            </HandledRoute>
            <Route path='*'>
              <Redirect to={protectedRoutes.userRegistration.path}></Redirect>
            </Route>
          </Switch>
        ) : user.sponsorman.status === 'ready_for_registry' ? (
          <Switch>
            <HandledRoute exact path={protectedRoutes.userRegistration.path}>
              <UserRegistration />
            </HandledRoute>
            <HandledRoute
              exact
              path={protectedRoutes.documentsRegistration.path}
            >
              <DocumentsRegistration />
            </HandledRoute>
            <Route path={'*'}>
              <Redirect
                to={protectedRoutes.documentsRegistration.path}
              ></Redirect>
            </Route>
          </Switch>
        ) : (
          <Switch>
            <HandledRoute exact path={protectedRoutes.dashboard.path}>
              <Dashboard />
            </HandledRoute>

            <HandledRoute exact path={protectedRoutes.userRegistration.path}>
              <UserRegistration />
            </HandledRoute>
            <HandledRoute
              exact
              path={protectedRoutes.documentsRegistration.path}
            >
              <DocumentsRegistration />
            </HandledRoute>
            <HandledRoute exact path={protectedRoutes.profile.path}>
              <Profile />
            </HandledRoute>
            <HandledRoute
              exact
              path={protectedRoutes.sponsorRequestCreate.path}
            >
              <SponsorRequestCreate />
            </HandledRoute>
            <HandledRoute exact path={protectedRoutes.sponsorRequestEdit.path}>
              <SponsorRequestEdit />
            </HandledRoute>
            <HandledRoute exact path={protectedRoutes.sponsorRequestShow.path}>
              <SponsorRequestShow />
            </HandledRoute>
          </Switch>
        )}
      </Route>

      <HandledRoute exact path={routes.userConfirm.path}>
        <UserConfirm />
      </HandledRoute>

      {/* Redirect to Dashboard when reaching public routes, like login ecc. */}
      <Route exact path={getPublicRoutes()}>
        <Redirect to={protectedRoutes.dashboard.path}></Redirect>
      </Route>

      <HandledRoute path='*'>
        <PageNotFound />
      </HandledRoute>
    </Switch>
  )
}

export default PrivateAppRouter
